"use client";

import AgesFilter from "@/app/[locale]/components/course/AgesFilter";

import React, { useState } from "react";
import ProjectCard from "@/app/[locale]/components/projects/ProjectCard";
import { useRouter } from "next/navigation";
import SearchInput from "@/app/[locale]/components/inputs/SearchInput";
import { ProjectType } from "@/app/types/projectTypes";
import Highlighter from "../../components/typography/Highlighter";

type ProjectsListPropsType = {
  search?: boolean;
  projects: ProjectType[];
};
function ProjectsList({ search, projects }: ProjectsListPropsType) {
  const router = useRouter();

  const [filters, setFilters] = useState({
    minAge: 0,
    maxAge: 100,
  });
  const filteredCourses = projects?.filter(
    (project) =>
      project?.studentAge >= filters.minAge &&
      project?.studentAge <= filters.maxAge
  );

  return (
    <div className="py-14  pt-[19rem] lg:pt-14  " id="agesFilter">
      <div className="container text-primary">
        <div className="max-md:container">
          <h1 className="text-[22px]  font-bold m-auto w-fit lg:text-[3.75rem]">
            <Highlighter iKey="projects.students_projects" />
          </h1>
          <p className="text-[16px] lg:text-[1.875rem] font-light  mx-auto leading-[20px] lg:leading-[40px]  text-center">
            <Highlighter iKey="projects.description" color="red" />
          </p>
          {search && (
            <div className="max-w-[36.5rem] m-auto lg:mt-[3.75rem] mt-[20px]">
              {" "}
              <SearchInput
                color="#F22E2E"
                onChange={(e) => {
                  router.replace(`/projects?search=${e.target.value}`);
                }}
              />
            </div>
          )}
          <AgesFilter
            onChange={(value) => {
              setFilters({
                minAge: value[0],
                maxAge: value[value.length - 1],
              });
            }}
          />
        </div>
        <div className=" grid grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-10">
          {filteredCourses.map((project, index) => (
            <ProjectCard index={index} project={project} key={project.id} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProjectsList;
